// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * MonitoringMode for a monitored item (OPC UA Part 4).
 */
export enum MonitoringMode {
  Disabled = 0,
  Sampling = 1,
  Reporting = 2,
}
